/* eslint-disable react/prop-types */
import React from 'react';
import { Col, Row } from 'react-flexbox-grid';

import Cover, { BackgroundImage, MainLogo, MainLogoContainer } from './styled-components';
import Middle from '../../../common/layouts/Middle';
import Paper from '../../components/Paper';
import AuthFlow from '../../layouts/AuthFlow';
import mainLogo from '../../../../assets/images/Sports_Connect_powered by_logo_white.png';
import Footer from '../../components/Footer';

const CredentialBoxWrapper = ({ ...props }) => (
  <Cover>
    <BackgroundImage />
    <Col xs={12} style={{ position: 'relative', zIndex: 2, marginTop: '-4em' }}>
      <Middle>
        <Row center="xs">
          <MainLogoContainer>
            <MainLogo src={mainLogo} alt="mainLogo" />
          </MainLogoContainer>
        </Row>
        <Paper>
          <AuthFlow {...props} />
        </Paper>
      </Middle>
    </Col>
    <Footer />
  </Cover>
);

export default CredentialBoxWrapper;



// WEBPACK FOOTER //
// ./src/views/sports-connect/layouts/CredentialsBoxWrapper/index.js